import React from "react";
import { Link } from "react-router-dom";
import CONSTANT from "./../../constant";
import Paging from "./../../component/common/Paging";
import Loader from "./../../component/common/Loader";
import { getAppraisalCycleList } from "../../actions/AppraisalCycleAction";
import { formatDateDDMMYY } from "../../utils";

class AppraisalCycleList extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      page: 1,
      limit: 50,
      list: undefined,
      count: 0,
      showLoader: false,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "Appraisal Cycles - " + CONSTANT.organisation.name;
    this.loadList();
  }

  render() {
    const { page, list, showLoader, limit } = this.state;

    return (
      <div className="container-fluid mb-3">
        <div className="row">
          <div className="col-md-12">
            <div className="card homedob">
              <div className="row">
                <div className="col-md-12">
                  <h1 className="page-title">Appraisal Cycles</h1>
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-md-6">
                  <Link
                    to={CONSTANT.component.aparAddAppraisalCycle.url}
                    className="btn btn-sm submit-button d-inline-block mr-3"
                  >
                    <i className="fa fa-plus-circle mr-2" />
                    Create New Cycle
                  </Link>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12 mt-3">
                  <div className="list-container">
                    <div className="table-container">
                      <div className="table-wrapper radius-4">
                        <table className="tablen">
                          <thead>
                            <tr className="text-center">
                              <th className="table-dark">#</th>
                              <th className="table-dark">Cycle Name</th>
                              <th className="table-dark">Financial Year</th>
                              <th className="table-dark">MoU</th>
                              <th className="table-dark">Weightage</th>
                              <th className="table-dark">Start Date</th>
                              <th className="table-dark">End Date</th>
                              <th className="table-dark">Status</th>
                              <th className="table-dark">Created On</th>
                              <th className="table-dark">Action</th>
                            </tr>
                          </thead>

                          <tbody>
                            {list === undefined && (
                              <tr>
                                <td colSpan={10} className="text-center">
                                  Loading...
                                </td>
                              </tr>
                            )}

                            {list !== undefined && list.length === 0 && (
                              <tr>
                                <td colSpan={10} className="text-center">
                                  No appraisal cycles found. Click "Create New Cycle" to get started.
                                </td>
                              </tr>
                            )}

                            {list !== undefined &&
                              list.map((item: any, index: number) => {
                                const editUrl =
                                  CONSTANT.component.aparEditAppraisalCycle.url.replace(
                                    ":code",
                                    item.code
                                  );

                                return (
                                  <tr
                                    key={item.id}
                                    className="c-pointer"
                                    onClick={() => this.props.history.push(editUrl)}
                                  >
                                    <td>
                                      {(page - 1) * limit + index + 1}
                                    </td>
                                    <td>{item.cycleName}</td>
                                    <td>{item.financialYear}</td>

                                    <td className="text-center">
                                      {item.isMouApplicable ? (
                                        <span className="badge badge-success">Yes</span>
                                      ) : (
                                        <span className="badge badge-secondary">No</span>
                                      )}
                                    </td>

                                    <td>
                                      {item.isMouApplicable ? (
                                        <span>20% MoU + 55% KPAs</span>
                                      ) : (
                                        <span>75% KPAs</span>
                                      )}
                                    </td>

                                    <td>{formatDateDDMMYY(item.startDate)}</td>
                                    <td>{formatDateDDMMYY(item.endDate)}</td>

                                    <td>
                                      <span
                                        className={`badge ${item.status === "Active"
                                            ? "badge-success"
                                            : item.status === "Completed"
                                              ? "badge-secondary"
                                              : item.status === "Cancelled"
                                                ? "badge-danger"
                                                : "badge-warning"
                                          }`}
                                      >
                                        {item.status}
                                      </span>
                                    </td>

                                    <td>
                                      {formatDateDDMMYY(item.createdOn)}
                                    </td>

                                    <td
                                      className="text-center"
                                      onClick={(e) => e.stopPropagation()}
                                    >
                                      <Link
                                        to={editUrl}
                                        className="btn btn-sm btn-primary mr-2"
                                      >
                                        <i className="fa fa-pencil" />
                                      </Link>
                                    </td>
                                  </tr>
                                );
                              })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {list !== undefined && (
                <Paging
                  page={page}
                  listItem={list}
                  onPageChange={this.changePage}
                />
              )}
            </div>
          </div>
        </div>

        {showLoader && <Loader />}
      </div>
    );
  }

  loadList = () => {
    this.setState({ showLoader: true });

    getAppraisalCycleList().then((res: any) => {
      if (res?.status === CONSTANT.static.apiStatus.success) {
        const mappedList = res.result.map((item: any) => ({
          id: item.id,
          code: item.id,
          cycleName: item.cycle_name,
          financialYear: item.financial_year,
          isMouApplicable: item.is_mou_applicable,
          status: item.status,
          startDate: item.start_date,
          endDate: item.end_date,
          createdOn: item.created_at,
        }));

        this.setState({
          list: mappedList,
          count: mappedList.length,
          showLoader: false,
        });
      } else {
        this.setState({
          list: [],
          showLoader: false,
        });
      }
    });
  };

  changePage = (e: any) => {
    const type = e.target.dataset.type;
    const page = type === "+" ? this.state.page + 1 : this.state.page - 1;

    this.setState({ page }, () => {
      this.loadList();
    });
  };
}

export default AppraisalCycleList;